'use strict';

/* globals yith_zendesk_chat */

// Settings configured here will be merged into the final config object.
export default {
	// Set to 'docked' or 'normal' for docked or normal mode respectively
	THEME: 'normal',
	USER_NAME: yith_zendesk_chat.user_name,
	USER_EMAIL: yith_zendesk_chat.user_email,
	SOUNDS: yith_zendesk_chat.sounds,
	LABELS: yith_zendesk_chat.labels
}



// WEBPACK FOOTER //
// ./src/config/base.js